import React, { useState, useEffect } from 'react';
import { Button, Form, Input, Modal, Spin, Select,message } from "antd";
import { updateLifterDispatch, getDoData } from '../../Services/Services';
import { EditOutlined } from '@ant-design/icons';
const UpdateLifterDispatch = (props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [doList, setdoList] = useState([])
    const [assignData, setassignData] = useState({})
    const [remQty, setRemQty] = useState(0)
    const [form] = Form.useForm();
    useEffect(() => {
        Get_Do_Details()
    }, [])
    if (props.disDetails) {
        form.setFieldsValue({
            do_id: props.disDetails.do_id,
            vehicle_no: props.disDetails.vehicle_no,
            truck_owner_name: props.disDetails.truck_owner_name,
            pan_no: props.disDetails.pan_no,
            advance: props.disDetails.advance,
            freight_rate: props.disDetails.freight_rate,
            date: props.disDetails.date,
            dispatch_quantity: props.disDetails.dispatch_quantity,
        })
    }
    const Get_Do_Details = async () => {
        const response = await getDoData({'com_name':localStorage.getItem('com_name')})
        if (response) {
            setdoList(response);
        }
    };
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleOk = () => {
        setIsModalOpen(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    const onFinish = async (values) => {
        setLoading(true);
        Object.assign(values, { 'lifter_id': localStorage.getItem('user_id'), 'client_id': assignData.client_id ,'shortage_rate':assignData.shortage_rate,'com_name':localStorage.getItem('com_name')})
        const response = await updateLifterDispatch(props.disDetails.id,values);
    
        setLoading(false);
        if (response) {
            const sortedArray = [...response].sort((a, b) => b.id - a.id);
            props.setdispatchList(sortedArray);
            props.setdispatchData(sortedArray)
            message.success('Dispatch Update Successful');
            form.resetFields();
            setIsModalOpen(false);
        } else {
            message.warning('Dispatch Update Not Successful');
        }
    };
    const Get_Do_Id = async (do_id) => {
        const rem_qty = doList.find(do_lis => do_lis.do_id === do_id)
        setRemQty(Number(rem_qty.rem_qty))
        setassignData(rem_qty)
        form.setFieldsValue({
            freight_rate:rem_qty.freight_rate
        }
            )

    };
    const handlePhoneKeyPress = (e) => {
        const maxValue = Number(e.target.value + e.key)
        if (remQty) {
            if (maxValue > Number(remQty)) {
                e.preventDefault()
                alert(`Your Remaining Qty  ${remQty} In Your Selected Do Number`)
            }
        }
        else {
            alert('Please Select Do Number')

        }
    };

    return (
        <>
            <Modal
                open={loading}
                footer={null}
                closable={false}
                width={400}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <img src='transduniyalogo.png' alt='img' width={200} style={{ margin: "10px" }} />

                    <Spin />
                    <h2>Dispatch Creating......</h2>
                </div>
            </Modal>
            {/* <Button onClick={showModal}
                style={{
                    //   margin:"10px",
                    backgroundColor: 'black',
                    color: 'white',
                    fontWeight: '600'
                }}
            > */}
                <EditOutlined onClick={showModal}/>
            {/* </Button> */}
            <Modal open={isModalOpen}
                onOk={handleOk} onCancel={handleCancel}
                footer={null}
            >
                <Form
                    form={form}
                    onFinish={onFinish}
                    layout="vertical"
                >
                    <div className=" grid grid-cols-1 sm:grid sm:grid-cols-2 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%] ">
                        <Form.Item
                            name="do_id"
                            rules={[
                                {
                                    required: true,
                                    message: "Please select the DO ID!",
                                },
                            ]}
                            label={<b>Select DO No</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Select
                                showSearch
                                placeholder="Search to Select"
                                optionFilterProp="children"
                                onChange={Get_Do_Id}
                            >
                                {doList.map((do_i) => (
                                    <Select.Option value={do_i.do_id}>
                                        {do_i.do_no}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            // rules={[
                            //     {
                            //         required: true,
                            //         message: "Please Enter Transporter Name!",
                            //     },
                            // ]}
                            name="truck_owner_name"
                            label={<b>Truck Owner Name</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Input placeholder="Truck Owner Name" size="middle" />
                        </Form.Item>

                        <Form.Item
                            name="pan_no"
                            // rules={[
                            //     {
                            //         required: true,
                            //         message: "Please Enter Pan No!",
                            //     },
                            // ]}
                            label={<b>PAN No</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Input placeholder="PAN No" size="middle" minLength={10} maxLength={10} />
                        </Form.Item>

                        <Form.Item
                            name="vehicle_no"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Vehicle No!",
                                },
                            ]}
                            label={<b>Vehicle No</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Input placeholder="Vehicle No" size="middle" maxLength={10} />
                        </Form.Item>

                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Dispatch Quantity!",
                                },
                            ]}
                            name="dispatch_quantity"
                            label={<b>Dispatch Quantity</b>
                            }
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Input placeholder="Dispatch Quantity" type="number" size="middle" 
                            // onKeyPress={handlePhoneKeyPress} 
                            />
                        </Form.Item>

                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Freight Rate!",
                                },
                            ]}
                            name="freight_rate"
                            label={<b>Freight Rate</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Input placeholder="Freight Rate" type="number" size="middle" disabled style={{ fontWeight: "600", color: "black" }}/>
                        </Form.Item>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Advance Amount!",
                                },
                            ]}
                            name="advance"
                            label={<b>Advance</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Input placeholder="Advance" type="number" size="middle" />
                        </Form.Item>
                        <Form.Item
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Dispatch Date!",
                                },
                            ]}
                            name="date"
                            label={<b>Dispatch Date</b>}
                            style={{ padding: "2px", margin: "2px" }}
                        >
                            <Input type="date" size="middle" />
                        </Form.Item>

                    </div>
                    <Form.Item className="text-center" style={{ textAlign: 'center' }}>
                        <Button
                            htmlType="submit"
                            // className="bg-[#3d348b] m-auto text-white flex gap-1 justify-center"
                            style={{ color: 'white', backgroundColor: 'black', fontSize: 'medium' }}
                        >
                            Update
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};
export default UpdateLifterDispatch;
